import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class SelectedOptionsService {
	public qcControl: any;

	public triggerBackButton: Subject<boolean>;

	constructor() {
		this.qcControl = {
			agent: 'all',
			campaign: 0,
			dateBy: 'lead_creation',
			replacement_status: 'All',
			dateRange: '',
			quantityPerPage: 25,
			page: 1,
			selectedTab: 'unreviewed',
			fromDate: '',
			toDate: '',
		};
		this.triggerBackButton = new Subject<boolean>();
	}

	public triggerBack(): void {
		this.triggerBackButton.next(true);
	}
}
